<template>
  <div class="content">
    <div class="card-box">
      <div class="top-box">
        <div class="search-box">
          <div class="left">
            <van-field
              class="id"
              label-width="1em"
              :border="false" 
              type="number"
              v-model="form.activityId" 
              label="ID" 
              placeholder="请输入ID" 
            />
            <van-field
              class="time"
              label-width="2.5em"
              readonly
              :border="false"
              label="时间"  
              v-model="time" 
              placeholder="请选择时间"
              @click="isTimeChange = true" 
            />
          </div>
        
          <div class="right">
            <van-button class="btn" type="primary" size="mini" color="#FF6B31" @click="search">查询</van-button>
            <van-button class="btn" type="default" size="mini" color="#E5E5E5" @click="reset">
              <span class="color">重置</span>
            </van-button>
          </div>
        </div>
        <div class="card-box">
          <div class="top-box">
            <div class="column">
              <div class="key">总销售额 (元)</div>
              <div class="value">{{ personalData.totalSalesVolume || 0 }}</div>
            </div>
          </div>
          <div class="bottom-box">
            <div class="column">
              <div class="key">待核销金额 (元)</div>
              <div class="value">{{ personalData.waitVerification || 0 }}</div>
            </div>
            <div class="column">
              <div class="key">已核销金额 (元)</div>
              <div class="value">{{ personalData.verificationed || 0}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row-box">
        <van-cell-group :border="false" title-class="title" size="large">
          <van-cell title="总报名订单" :value="personalData.totalSignUpNum || 0" />
          <van-cell title="待核销订单" :value="personalData.waitVerificationNum || 0" />
          <van-cell title="已核销订单" :value="personalData.verificationedNum || 0" />
        </van-cell-group> 
      </div>
    </div>
    <div class="tips-box">
      <div>提示：</div>
      1、默认为全部报名数据 <br />
      2、该显示金额为实际销售金额，而待提现余额是微信平台扣除手续费后的余额（且订单核销后才能提现）
    </div>
    <van-calendar 
      ref="calendarRef"
      v-model="isTimeChange" 
      allow-same-day
      type="range"
      :min-date="minDate"
      get-container="body"
      color="#FF6B31"
      @close="closeTime"
      @confirm="onConfirm"
    />
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'DataLook',
  data() {
    return {
      active: 2,
      isTimeChange: false,
      time: '',
      minDate: new Date(2010, 0, 1),
      form: {
        activityId: '',
        startTime: '',
        endTime: '',
      },
      personalData: {},
    }
  },
  mounted() {
    this.getActivitySignupData()
  },
  methods: {
    getActivitySignupData() {
      this.$api.h5.getActivitySignupData(this.form)
        .then(res => {
          this.personalData = res.data
        })
    },
    onConfirm(range) {
      const [start, end] = range;
      this.form.startTime = moment(start).format("YYYY-MM-DD") +' 00:00:00';
      this.form.endTime = moment(end).format("YYYY-MM-DD")+' 23:59:59';
      this.time = `${moment(start).format('MM-DD')}-${moment(end).format('MM-DD')}`
      this.isTimeChange = false
      this.search()
    },
    search() {
      this.getActivitySignupData()
    },
    reset() {
      for(let [key,value] of Object.entries(this.form)) {
        this.form[key] = ''
      }
      this.time  = ''
      this.search()
      this.$refs.calendarRef.reset()
    },
    closeTime() {
      this.isTimeChange = false
    },
  }
}
</script>

<style scoped lang="stylus">
  .card-box {
    background: #fff;
    border-radius: 8px;
    padding: 10px 0;
    .top-box {
      padding: 0px 10px;
      .search-box {
        display: flex;
        justify-content: space-between;
        .left {
          flex: 1;
          display: flex;
          /deep/ .van-cell  {
            background: transparent;
            padding: 0;
          }
          /deep/ .van-field__value  {
            border-bottom: 1px solid #D8D8D8;
          }
          .id {
            width: 150px;
            margin-right: 10px;
          }
        }
        .right {
          display: flex;
          margin-left: 10px;
          .id {
            width: 90px;
            margin-right: 10px;
          }
          .time {
            width: 140px;
            margin-right: 10px;
          }
          .btn {
            width: 40px;
            .color {
              color: #666666;
            }
          }
        }
      }
      .card-box {
        background: #FFFAF3;
        border-radius: 4px;
        margin-top: 15px;
        .column {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          .key {
            color: #666666;
          }
          .value {
            font-size: 18px;
            color: #FF6B31;
            font-weight: bold;
            margin-top: 8px;
          }
        }
        .bottom-box {
          display: flex;
          justify-content: space-around;
          margin-top: 10px;
          .column .value {
            font-size: 16px;
            color: #333333;
          }
        }
      }
    }
    .row-box {
      margin-top: 10px;
      /deep/ .van-cell__title{
        color: #666666;
      }
      /deep/ .van-cell__value {
        color: #333333;
      }
    }
  }
  .tips-box {
    color: #999999;
    margin: 10px;
    font-size: 13px;
    line-height: 20px;

  }
   
</style>
